/* Shared deep-surface chrome (Package 4) — the context bar (crumbs + surface-tab
 * pill) used by all four client deep-surface pages: Search · News · AI ·
 * Wikipedia. All four tabs now route for real to #/client/{slug}/{surface}
 * (News routes to its honest not-wired page). Tokens-only via wikiWorkroom.css's
 * .ww-context / .ww-stab classes. */
import { html, nothing, type TemplateResult } from 'lit';

export type Surface = 'search' | 'news' | 'ai' | 'wiki';

const CRUMB_TITLE: Record<Surface, string> = {
  search: 'Search visibility',
  news: 'Google News',
  ai: 'AI narrative',
  wiki: 'Wikipedia & Wikidata',
};

/** The deep-surface context bar: back link + intelligence crumbs + the
 * surface-tab pill (Search/News/AI/Wikipedia), the active one highlighted. */
export function surfaceContextBar(brand: string, slug: string, active: Surface): TemplateResult {
  const tab = (id: Surface, label: string): TemplateResult => html`<a
    class=${`ww-stab ${active === id ? 'active' : ''}`}
    href=${`#/client/${slug}/${id}`}
    aria-current=${active === id ? 'page' : nothing}>${label}</a>`;
  return html`<div class="ww-context">
    <a class="ww-back" href=${`#/client/${slug}`}>← ${brand}</a>
    <div class="ww-crumbs"><b>${brand}</b> · Intelligence · <b>${CRUMB_TITLE[active]}</b></div>
    <div class="ww-surface-tabs" role="tablist" aria-label="client surfaces">
      ${tab('search', 'Search')}
      ${tab('news', 'News')}
      ${tab('ai', 'AI')}
      ${tab('wiki', 'Wikipedia')}
    </div>
  </div>`;
}
